/* ============================================================
   VA Flipbook — Vanilla JS 3D Page Turn
   Version 2.0 — No jQuery, no external dependencies
   ============================================================ */

(function () {
  'use strict';

  var FLIP_MS = 750; // must match CSS transition duration

  /* ── Build spreads array from flat pages array ─────────────────────────────
     Spread 0 : { left: null,      right: pages[0] }  ← cover
     Spread k  : { left: pages[2k-1], right: pages[2k] }
     Last spread may have right: null if page count is odd.
  ────────────────────────────────────────────────────────────────────────── */
  function buildSpreads(pages) {
    var spreads = [];
    spreads.push({ left: null, right: pages[0] || null });
    for (var i = 1; i < pages.length; i += 2) {
      spreads.push({
        left:  pages[i],
        right: pages[i + 1] || null
      });
    }
    return spreads;
  }

  /* ── VaFlipbook constructor ─────────────────────────────────────────────── */
  function VaFlipbook(sectionId, pages) {
    this.sectionId = sectionId;
    this.pages     = pages || [];
    this.spreads   = buildSpreads(this.pages);
    this.spreadIdx = 0;    // double-page current spread index
    this.singleIdx = 0;    // single-page current page index
    this.isTurning = false;
    this.zoomScale = 1;

    var root = document.getElementById('va-book-' + sectionId);
    if (!root) return;
    if (root.dataset.vaReady) return; // prevent double init
    root.dataset.vaReady = '1';
    this.root = root;

    // Cache DOM elements
    this.stageEl      = root.querySelector('.va-book__stage');
    this.leftHalf     = root.querySelector('.va-book__left');
    this.rightHalf    = root.querySelector('.va-book__right');
    this.leftImg      = root.querySelector('.va-book__left .va-book__page-img');
    this.rightImg     = root.querySelector('.va-book__right .va-book__page-img');
    this.turningEl    = root.querySelector('.va-turning');
    this.frontImg     = root.querySelector('.va-turning__front .va-book__page-img');
    this.backImg      = root.querySelector('.va-turning__back .va-book__page-img');
    this.btnPrev      = root.querySelector('.va-ctrl-prev');
    this.btnNext      = root.querySelector('.va-ctrl-next');
    this.btnZoomIn    = root.querySelector('.va-ctrl-zoom-in');
    this.btnZoomOut   = root.querySelector('.va-ctrl-zoom-out');
    this.btnFS        = root.querySelector('.va-ctrl-fullscreen');
    this.indicator    = root.querySelector('.va-page-indicator');
    this.spreadEl     = root.querySelector('.va-book__spread');
    this.thumbsTrack  = root.querySelector('.va-thumbs__track');
    this.thumbsPrev   = root.querySelector('.va-thumbs__scroll--prev');
    this.thumbsNext   = root.querySelector('.va-thumbs__scroll--next');
    this.thumbs       = [];

    this._bindEvents();
    this._updateMode();
    this._buildThumbs();
    this._render();
    this._preloadAll();
  }

  /* ── Mode detection ────────────────────────────────────────────────────── */

  VaFlipbook.prototype._isSingle = function () {
    return this.root.classList.contains('va-book--single');
  };

  VaFlipbook.prototype._updateMode = function () {
    var single = window.innerWidth < 768;
    this.root.classList.toggle('va-book--single', single);
    if (single) {
      // Keep singleIdx in sync with spreadIdx
      var s = this.spreads[this.spreadIdx];
      if (this.spreadIdx === 0) {
        this.singleIdx = 0;
      } else {
        this.singleIdx = s.right
          ? this.spreadIdx * 2
          : this.spreadIdx * 2 - 1;
      }
    }
  };

  /* ── Image helpers ─────────────────────────────────────────────────────── */

  VaFlipbook.prototype._setImg = function (imgEl, halfEl, page) {
    if (!imgEl) return;
    if (page && page.large) {
      imgEl.src = page.large;
      imgEl.alt = 'Página';
      imgEl.style.opacity = '1';
      if (halfEl) halfEl.classList.remove('va-page--blank');
    } else {
      imgEl.src = '';
      imgEl.alt  = '';
      imgEl.style.opacity = '0';
      if (halfEl) halfEl.classList.add('va-page--blank');
    }
  };

  /* ── Indicator + button state ──────────────────────────────────────────── */

  VaFlipbook.prototype._updateIndicator = function () {
    if (!this.indicator) return;
    var n = this.pages.length;
    if (n === 0) { this.indicator.textContent = '–'; return; }

    if (this._isSingle()) {
      this.indicator.textContent = (this.singleIdx + 1) + ' / ' + n;
      return;
    }

    var s = this.spreads[this.spreadIdx];
    // Compute 1-based page numbers
    var leftNum  = s.left  ? (this.spreadIdx * 2)     : null;
    var rightNum = s.right ? (this.spreadIdx === 0 ? 1 : this.spreadIdx * 2 + 1) : null;

    if (leftNum && rightNum) {
      this.indicator.textContent = leftNum + '–' + rightNum + ' / ' + n;
    } else {
      this.indicator.textContent = (rightNum || leftNum || 1) + ' / ' + n;
    }
  };

  VaFlipbook.prototype._updateBtns = function () {
    var atStart, atEnd;
    if (this._isSingle()) {
      atStart = this.singleIdx <= 0;
      atEnd   = this.singleIdx >= this.pages.length - 1;
    } else {
      atStart = this.spreadIdx <= 0;
      atEnd   = this.spreadIdx >= this.spreads.length - 1;
    }
    if (this.btnPrev) this.btnPrev.disabled = atStart;
    if (this.btnNext) this.btnNext.disabled = atEnd;
    if (this.btnZoomIn)  this.btnZoomIn.disabled  = this.zoomScale >= 3;
    if (this.btnZoomOut) this.btnZoomOut.disabled = this.zoomScale <= 0.5;
  };

  /* ── Render current state to DOM ───────────────────────────────────────── */

  VaFlipbook.prototype._render = function () {
    if (this._isSingle()) {
      this._setImg(this.rightImg, this.rightHalf, this.pages[this.singleIdx]);
      this._setImg(this.leftImg,  this.leftHalf,  null);
      this.root.classList.remove('va-book--right-solo', 'va-book--left-solo');
    } else {
      var s = this.spreads[this.spreadIdx];
      this._setImg(this.leftImg,  this.leftHalf,  s.left);
      this._setImg(this.rightImg, this.rightHalf, s.right);
      this.root.classList.toggle('va-book--right-solo', !s.left && !!s.right);
      this.root.classList.toggle('va-book--left-solo',  !!s.left && !s.right);
    }
    this._updateIndicator();
    this._updateBtns();
    this._syncThumbs();
    this._preloadAdjacent();
  };

  /* ── Image preloading ─────────────────────────────────────────────────────
     _preloadPage    : fires a background Image() for one page object;
                       no-op if already started (page._img flag is set).
     _preloadAdjacent: immediately preloads ±2 spreads around the current one.
                       Called on every _render() so it follows the reader.
     _preloadAll     : sequentially preloads the full page list via
                       requestIdleCallback so the browser does it when idle
                       and never competes with visible rendering.
  ────────────────────────────────────────────────────────────────────────── */

  VaFlipbook.prototype._preloadPage = function (page) {
    if (!page || !page.large || page._img) return;
    page._img = new Image();
    page._img.src = page.large;
  };

  VaFlipbook.prototype._preloadAdjacent = function () {
    var ahead  = Math.min(this.spreadIdx + 2, this.spreads.length - 1);
    var behind = Math.max(this.spreadIdx - 1, 0);
    for (var i = behind; i <= ahead; i++) {
      var s = this.spreads[i];
      this._preloadPage(s.left);
      this._preloadPage(s.right);
    }
  };

  VaFlipbook.prototype._preloadAll = function () {
    var idx   = 0;
    var pages = this.pages;
    function loadNext() {
      if (idx >= pages.length) return;
      var p = pages[idx++];
      if (p && p.large && !p._img) {
        p._img = new Image();
        p._img.onload = p._img.onerror = loadNext;
        p._img.src = p.large;
      } else {
        loadNext(); // already preloaded, skip to next
      }
    }
    // Defer so the first render is never blocked
    if (typeof requestIdleCallback !== 'undefined') {
      requestIdleCallback(function () { loadNext(); });
    } else {
      setTimeout(loadNext, 400);
    }
  };

  /* ── Single page navigation (fade) ────────────────────────────────────── */

  VaFlipbook.prototype._singleNext = function () {
    if (this.singleIdx >= this.pages.length - 1) return;
    this.singleIdx++;
    this.spreadIdx = Math.ceil(this.singleIdx / 2);
    this._fadeSwap(1);
  };

  VaFlipbook.prototype._singlePrev = function () {
    if (this.singleIdx <= 0) return;
    this.singleIdx--;
    this.spreadIdx = Math.ceil(this.singleIdx / 2);
    this._fadeSwap(-1);
  };

  /* ── Wait for <img> elements to decode before showing the turning leaf ────
     Uses img.decode() (Promise, all modern browsers) so the turning leaf is
     only made visible once both images are painted — no white-flash on flip.
     Falls back to onload/onerror for any edge case.
     Already-cached images (complete + naturalWidth > 0) resolve instantly.
  ────────────────────────────────────────────────────────────────────────── */
  function waitImages(imgs, cb) {
    var pending = imgs.length;
    if (!pending) { cb(); return; }
    function done() { if (--pending === 0) cb(); }
    imgs.forEach(function (img) {
      // Already decoded (cache hit) — resolve sync
      if (!img.src || (img.complete && img.naturalWidth > 0)) {
        done(); return;
      }
      if (typeof img.decode === 'function') {
        img.decode().then(done, done);
      } else {
        img.onload  = done;
        img.onerror = done;
      }
    });
  }

  VaFlipbook.prototype._fadeSwap = function () {
    var self = this;
    var img = this.rightImg;
    img.style.transition = 'opacity 0.3s ease';
    img.style.opacity = '0';
    setTimeout(function () {
      self._setImg(img, self.rightHalf, self.pages[self.singleIdx]);
      self._updateIndicator();
      self._updateBtns();
      self._syncThumbs();
    }, 320);
  };

  /* ── Double page 3D flip — FORWARD ────────────────────────────────────── */
  //
  //  Turning element: positioned at RIGHT half (left: 50%, width: 50%)
  //  transform-origin: left center  (pivot = center spine)
  //  Animation: rotateY(0deg) → rotateY(-180deg)
  //  Front  = current right page  (visible at start, covers rightHalf)
  //  Back   = next left page      (visible at end, rotateY(180deg) pre-applied)
  //  Right half (static, behind leaf) = next right page — revealed as leaf sweeps left

  VaFlipbook.prototype._flipNext = function () {
    var self = this;
    var curS  = this.spreads[this.spreadIdx];
    var nxtS  = this.spreads[this.spreadIdx + 1];

    this.root.classList.remove('va-book--right-solo', 'va-book--left-solo');

    this._setImg(this.frontImg,  null,           curS.right);
    this._setImg(this.backImg,   null,           nxtS.left);
    // Pre-load next right page into the static half so it shows behind the
    // turning leaf as it sweeps left — no blank area exposed.
    this._setImg(this.rightImg,  this.rightHalf, nxtS.right);

    this.turningEl.style.left            = '50%';
    this.turningEl.style.transformOrigin = 'left center';
    this.turningEl.style.transition      = 'none';
    this.turningEl.style.transform       = 'rotateY(0deg)';
    // va-turning--active is added AFTER images decode to avoid white-flash

    this.root.classList.add('va-book--flipping-fwd');

    // Wait for all three images to be decoded before starting the animation
    waitImages([this.frontImg, this.backImg, this.rightImg], function () {
      self.turningEl.classList.add('va-turning--active');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          self.turningEl.style.transition = 'transform ' + FLIP_MS + 'ms cubic-bezier(0.37,0,0.63,1)';
          self.turningEl.style.transform  = 'rotateY(-180deg)';
        });
      });
    });

    setTimeout(function () {
      self.spreadIdx++;
      self._render();
      self.turningEl.classList.remove('va-turning--active');
      self.turningEl.style.transition = 'none';
      self.root.classList.remove('va-book--flipping-fwd');
      self.isTurning = false;
    }, FLIP_MS + 60);
  };

  /* ── Double page 3D flip — BACKWARD ───────────────────────────────────── */
  //
  //  Turning element: positioned at LEFT half (left: 0, width: 50%)
  //  transform-origin: right center  (pivot = center spine)
  //  Animation: rotateY(0deg) → rotateY(180deg)
  //  Front = current left page  (visible at start, covers left half)
  //  Back  = previous right page (visible at end, appears on right half)

  VaFlipbook.prototype._flipPrev = function () {
    var self = this;
    var curS  = this.spreads[this.spreadIdx];
    var prvS  = this.spreads[this.spreadIdx - 1];

    this.root.classList.remove('va-book--right-solo', 'va-book--left-solo');

    this._setImg(this.frontImg, null, curS.left);
    this._setImg(this.backImg,  null, prvS.right);

    this.turningEl.style.left            = '0';
    this.turningEl.style.transformOrigin = 'right center';
    this.turningEl.style.transition      = 'none';
    this.turningEl.style.transform       = 'rotateY(0deg)';
    // va-turning--active is added AFTER images decode to avoid white-flash

    this.leftHalf.style.visibility = 'hidden';
    this.root.classList.add('va-book--flipping-bwd');

    waitImages([this.frontImg, this.backImg], function () {
      self.turningEl.classList.add('va-turning--active');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          self.turningEl.style.transition = 'transform ' + FLIP_MS + 'ms cubic-bezier(0.37,0,0.63,1)';
          self.turningEl.style.transform  = 'rotateY(180deg)';
        });
      });
    });

    setTimeout(function () {
      self.spreadIdx--;
      self._render();
      self.turningEl.classList.remove('va-turning--active');
      self.turningEl.style.transition     = 'none';
      self.leftHalf.style.visibility      = '';
      self.root.classList.remove('va-book--flipping-bwd');
      self.isTurning = false;
    }, FLIP_MS + 60);
  };

  /* ── Public navigation API ─────────────────────────────────────────────── */

  VaFlipbook.prototype.goNext = function () {
    if (this.isTurning) return;
    if (this._isSingle()) { this._singleNext(); return; }
    if (this.spreadIdx >= this.spreads.length - 1) return;
    this.isTurning = true;
    this._flipNext();
  };

  VaFlipbook.prototype.goPrev = function () {
    if (this.isTurning) return;
    if (this._isSingle()) { this._singlePrev(); return; }
    if (this.spreadIdx <= 0) return;
    this.isTurning = true;
    this._flipPrev();
  };

  VaFlipbook.prototype.zoom = function (delta) {
    this.zoomScale = Math.min(3, Math.max(0.5, parseFloat((this.zoomScale + delta).toFixed(2))));
    if (this.stageEl) {
      this.stageEl.style.transform = 'scale(' + this.zoomScale + ')';
    }
    this._updateBtns();
  };

  /* ── Event bindings ────────────────────────────────────────────────────── */

  VaFlipbook.prototype._bindEvents = function () {
    var self = this;

    // Control buttons
    if (this.btnPrev)    this.btnPrev.addEventListener('click',    function () { self.goPrev(); });
    if (this.btnNext)    this.btnNext.addEventListener('click',    function () { self.goNext(); });
    if (this.btnZoomIn)  this.btnZoomIn.addEventListener('click',  function () { self.zoom(+0.25); });
    if (this.btnZoomOut) this.btnZoomOut.addEventListener('click', function () { self.zoom(-0.25); });

    if (this.btnFS) {
      this.btnFS.addEventListener('click', function () {
        if (document.fullscreenElement || document.webkitFullscreenElement) {
          (document.exitFullscreen || document.webkitExitFullscreen || function () {}).call(document);
        } else {
          var el = self.root;
          (el.requestFullscreen || el.webkitRequestFullscreen || el.mozRequestFullScreen || function () {}).call(el);
        }
      });
    }

    // Click on corner zones — only if pointer is within 70px of a corner
    if (this.rightHalf) {
      this.rightHalf.addEventListener('click', function (e) {
        var r  = self.rightHalf.getBoundingClientRect();
        var cx = e.clientX - r.left;
        var cy = e.clientY - r.top;
        if (cx > r.width - 70 && (cy < 70 || cy > r.height - 70)) {
          self.goNext();
        }
      });
    }
    if (this.leftHalf) {
      this.leftHalf.addEventListener('click', function (e) {
        var r  = self.leftHalf.getBoundingClientRect();
        var cx = e.clientX - r.left;
        var cy = e.clientY - r.top;
        if (cx < 70 && (cy < 70 || cy > r.height - 70)) {
          self.goPrev();
        }
      });
    }

    // Keyboard navigation (only when this book is focused/hovered)
    document.addEventListener('keydown', function (e) {
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;
      if (e.key === 'ArrowRight' || e.key === 'PageDown') { e.preventDefault(); self.goNext(); }
      if (e.key === 'ArrowLeft'  || e.key === 'PageUp')   { e.preventDefault(); self.goPrev(); }
      if (e.key === '+' || e.key === '=') self.zoom(+0.25);
      if (e.key === '-')                   self.zoom(-0.25);
    });

    // Touch / swipe
    var tx0 = 0, ty0 = 0, swipeInThumbs = false;
    this.root.addEventListener('touchstart', function (e) {
      tx0 = e.touches[0].clientX;
      ty0 = e.touches[0].clientY;
      // Swiping the thumbnail strip must scroll it, never turn the page
      swipeInThumbs = !!(e.target.closest && e.target.closest('.va-thumbs'));
    }, { passive: true });

    this.root.addEventListener('touchend', function (e) {
      if (swipeInThumbs) return;
      var dx = e.changedTouches[0].clientX - tx0;
      var dy = e.changedTouches[0].clientY - ty0;
      if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.2) {
        if (dx < 0) self.goNext();
        else        self.goPrev();
      }
    }, { passive: true });

    // Window resize: toggle single/double mode
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var wasSingle = self._isSingle();
        self._updateMode();
        if (wasSingle !== self._isSingle()) {
          self._render();
        }
      }, 150);
    });
  };

  /* ── Thumbnail navigation strip ────────────────────────────────────────── */

  VaFlipbook.prototype._prefersReducedMotion = function () {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  };

  VaFlipbook.prototype._buildThumbs = function () {
    var self  = this;
    var track = this.thumbsTrack;
    if (!track) return;

    track.innerHTML = '';
    this.thumbs = [];

    var frag = document.createDocumentFragment();
    for (var i = 0; i < this.pages.length; i++) {
      var page = this.pages[i] || {};
      var btn  = document.createElement('button');
      btn.type = 'button';
      btn.className = 'va-thumb';
      btn.setAttribute('aria-label', 'Ir a la página ' + (i + 1));
      btn.dataset.index = String(i);

      var img = document.createElement('img');
      img.src      = page.thumb || page.large || '';
      img.alt      = '';
      img.loading  = 'lazy';
      img.decoding = 'async';
      img.width    = 400;
      img.height   = 416;
      img.setAttribute('draggable', 'false');
      btn.appendChild(img);

      var num = document.createElement('span');
      num.className   = 'va-thumb__num';
      num.textContent = String(i + 1);
      btn.appendChild(num);

      // Closure keeps the page index for each thumbnail
      btn.addEventListener('click', (function (index) {
        return function () { self.goToPage(index); };
      }(i)));

      this.thumbs.push(btn);
      frag.appendChild(btn);
    }
    track.appendChild(frag);

    if (this.thumbsPrev) {
      this.thumbsPrev.onclick = function () { self._scrollThumbs(-1); };
    }
    if (this.thumbsNext) {
      this.thumbsNext.onclick = function () { self._scrollThumbs(1); };
    }
    track.onscroll = function () {
      self._updateThumbsScrollBtns();
    };

    this._bindThumbDrag();
    this._updateThumbsScrollBtns();
  };

  /* ── Mouse drag on the strip (desktop) ───────────────────────────────────
     Native touch scrolling already works on mobile. With a mouse we emulate
     the same feel: press and drag to scroll; a real drag cancels the click so
     the strip does not jump to a page by accident.
  ────────────────────────────────────────────────────────────────────────── */
  VaFlipbook.prototype._bindThumbDrag = function () {
    var self  = this;
    var track = this.thumbsTrack;
    if (!track) return;

    var dragging = false;
    var moved    = false;
    var startX   = 0;
    var startLeft = 0;
    var pointerId = null;

    track.onpointerdown = function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      dragging  = true;
      moved     = false;
      startX    = e.clientX;
      startLeft = track.scrollLeft;
      pointerId = e.pointerId;
    };

    track.onpointermove = function (e) {
      if (!dragging || e.pointerId !== pointerId) return;
      var dx = e.clientX - startX;

      if (!moved && Math.abs(dx) > 5) {
        moved = true;
        track.classList.add('va-thumbs__track--dragging');
        if (track.setPointerCapture) {
          try { track.setPointerCapture(pointerId); } catch (err) {}
        }
      }
      if (!moved) return;

      e.preventDefault();
      track.scrollLeft = startLeft - dx;
      self._updateThumbsScrollBtns();
    };

    var endDrag = function () {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('va-thumbs__track--dragging');

      if (pointerId !== null && track.releasePointerCapture) {
        try { track.releasePointerCapture(pointerId); } catch (err) {}
      }
      pointerId = null;

      if (moved) {
        // Swallow the click that follows the drag
        var blockClick = function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          track.removeEventListener('click', blockClick, true);
        };
        track.addEventListener('click', blockClick, true);
        setTimeout(function () {
          track.removeEventListener('click', blockClick, true);
        }, 0);
      }
    };

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
  };

  VaFlipbook.prototype._scrollThumbs = function (direction) {
    if (!this.thumbsTrack) return;
    var amount = Math.max(120, this.thumbsTrack.clientWidth * 0.8);
    this.thumbsTrack.scrollBy({
      left: direction * amount,
      behavior: this._prefersReducedMotion() ? 'auto' : 'smooth'
    });
  };

  VaFlipbook.prototype._updateThumbsScrollBtns = function () {
    var track = this.thumbsTrack;
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth;
    if (this.thumbsPrev) this.thumbsPrev.hidden = track.scrollLeft <= 4;
    if (this.thumbsNext) this.thumbsNext.hidden = track.scrollLeft >= max - 4;
  };

  VaFlipbook.prototype._syncThumbs = function () {
    if (!this.thumbs || !this.thumbs.length) return;

    var active = {};
    var i;

    if (this._isSingle()) {
      active[this.singleIdx] = true;
    } else {
      var s = this.spreads[this.spreadIdx];
      if (s) {
        for (i = 0; i < this.pages.length; i++) {
          if (this.pages[i] === s.left || this.pages[i] === s.right) active[i] = true;
        }
      }
    }

    var first = -1;
    for (i = 0; i < this.thumbs.length; i++) {
      var on = !!active[i];
      this.thumbs[i].setAttribute('aria-current', on ? 'true' : 'false');
      if (on && first < 0) first = i;
    }

    if (first >= 0 && this.thumbsTrack) {
      var el   = this.thumbs[first];
      var left = el.offsetLeft - (this.thumbsTrack.clientWidth - el.offsetWidth) / 2;
      this.thumbsTrack.scrollTo({
        left: Math.max(0, left),
        behavior: this._prefersReducedMotion() ? 'auto' : 'smooth'
      });
      this._updateThumbsScrollBtns();
    }
  };

  VaFlipbook.prototype.goToPage = function (index) {
    if (this.isTurning) return;
    var total = this.pages.length;
    if (!total) return;

    index = parseInt(index, 10);
    if (isNaN(index)) index = 0;
    index = Math.max(0, Math.min(total - 1, index));

    if (this._isSingle()) this.singleIdx = index;
    this.spreadIdx = index === 0 ? 0 : Math.ceil(index / 2);

    this._render();
  };

  /* ── Auto-init logic ─────────────────────────────────────────────────────
     Called once on DOMContentLoaded and again on shopify:section:load.
     Looks for .va-book[data-va-id] elements without data-va-ready.
  ────────────────────────────────────────────────────────────────────────── */
  function vaInitAll() {
    var books = document.querySelectorAll('.va-book[data-va-id]:not([data-va-ready])');
    for (var i = 0; i < books.length; i++) {
      var el        = books[i];
      var sectionId = el.dataset.vaId;
      var engine    = el.dataset.vaEngine || 'css3';
      var dataEl    = document.getElementById('va-data-' + sectionId);
      var pages     = [];
      try {
        pages = JSON.parse((dataEl && dataEl.textContent) || '[]');
      } catch (e) {
        pages = [];
      }
      if (engine === 'canvas') {
        // Delegate to VaFlipbookCanvas; vaInitCanvas is defined in va-flipbook-canvas.js
        if (typeof window.vaInitCanvas === 'function') {
          window.vaInitCanvas(sectionId, pages);
        }
      } else {
        new VaFlipbook(sectionId, pages);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vaInitAll);
  } else {
    vaInitAll();
  }

  // Shopify Theme Editor: re-init on section load/reload
  document.addEventListener('shopify:section:load', function () {
    setTimeout(function () {
      // Reset ready flags on reloaded sections so they can re-init
      var books = document.querySelectorAll('.va-book[data-va-id]');
      for (var i = 0; i < books.length; i++) {
        delete books[i].dataset.vaReady;
      }
      vaInitAll();
    }, 50);
  });

  // Expose constructor for manual use
  window.VaFlipbook = VaFlipbook;

}());
